export default [
  {
    path: '/minting',
    component: () => import('./views/Index'),
    name: 'minting-nft-image-pool',
    redirect: { name: 'nft-image-pool-list' },
    children: [
      {
        path: 'nft-image-pool',
        name: 'nft-image-pool-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'goga-earn',
        },
      },
    ],
  },
]
